export default __webpack_public_path__ + "static/media/image.accio-pvt-ltd.110e3b63.png";